<div class="central-email-wrapper">
  <span class="title">{{
    '+SETTINGS.NOTIFICATION_SETTINGS_CENTRAL_COMPANY_EMAIL' | translate
  }}</span>
  <span class="description">{{
    '+SETTINGS.NOTIFICATION_SETTINGS_CENTRAL_COMPANY_EMAIL_DESCRIPTION' | translate
  }}</span>
  <ng-container [ngSwitch]="notificationsStore.centralEmailStatus$ | async">
    <ng-container *ngSwitchCase="CentrailMailStatus.Default">
      <vi-loader data-at-loader [isLoading]="true"></vi-loader>
    </ng-container>

    <ng-container *ngSwitchCase="CentrailMailStatus.Loading">
      <vi-loader data-at-loader [isLoading]="true"></vi-loader>
    </ng-container>

    <ng-container *ngSwitchCase="CentrailMailStatus.Error">
      <app-banner type="error">
        {{ '+SETTINGS.NOTIFICATION_SETTINGS_CENTRAL_COMPANY_EMAIL_ERROR' | translate }}
      </app-banner>
    </ng-container>

    <ng-container *ngSwitchCase="CentrailMailStatus.Loaded">
      <mat-form-field mat-input-height-large-label>
        <mat-label>{{
          '+SETTINGS.NOTIFICATION_SETTINGS_CENTRAL_COMPANY_EMAIL' | translate
        }}</mat-label>
        <input
          #input
          matInput
          [formControl]="centralEmailForm"
          [readonly]="dataSaving"
          (keyup)="onInputValueChange(centralEmailForm.value)"
          fieldTextContentTooltip
        />
      </mat-form-field>
      <div class="central-email-actions-wrapper" *ngIf="tileFocused">
        <div>
          <button
            gtm="onSelect"
            gtmAction="Central Email Cancel"
            gtmCategory="settings"
            mat-button
            appSmallButton
            color="primary"
            (click)="cancelChanges()"
            [disabled]="dataSaving"
          >
            {{ 'GENERAL.BUTTON.CANCEL' | translate }}
          </button>
        </div>
        <div>
          <button
            *ngIf="!!currentEmail"
            [disabled]="dataSaving"
            gtm="onSelect"
            gtmAction="Central Email Reset"
            gtmCategory="settings"
            mat-button
            mat-stroked-button
            appSmallButton
            color="primary"
            (click)="resetToDefault()"
          >
            {{ 'GENERAL.BUTTON.RESET' | translate }}
          </button>

          <button
            gtm="onSelect"
            gtmAction="Central Save"
            gtmCategory="settings"
            mat-button
            mat-raised-button
            appSmallButton
            color="primary"
            class="save-btn"
            (click)="onSave()"
            [disabled]="!centralEmailForm.valid || blockSaving || dataSaving"
          >
            <ng-container
              *ngIf="dataSaving; then btnCalculatingChanges; else btnSave"
            ></ng-container>

            <ng-template #btnCalculatingChanges>
              <mat-icon class="spin">autorenew</mat-icon>
            </ng-template>

            <ng-template #btnSave>
              {{ 'GENERAL.BUTTON.SAVE' | translate }}
            </ng-template>
          </button>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
